import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-white" data-id="element-17" data-mp="bfj6p4q0ph8">
      <div className="mx-auto max-w-3xl px-4 py-5 sm:py-8" data-id="element-18" data-mp="3iqztf3fsgbxb">
        <SectionHeader id="beneficios" title="¿Qué puede cambiar cuando empiezas?" description="Un sistema organizado puede cambiar la forma en que preparas tus clases." data-id="element-19" data-mp="3npb6dn1dr2jr" />
        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-20" data-mp="3dqvehhuj3p97">
          {benefits.map(b => {
          const Icon = b.icon;
          return <li key={b.title} className="flex gap-2.5 rounded-lg border border-navy/10 bg-mist p-3" data-id="element-21" data-mp="2zsnipd98atzm">
                <span aria-hidden="true" className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-md bg-navy text-energy" data-id="element-22" data-mp="34qyuhtj33ekh">
                  <Icon size={16} data-id="element-23" data-mp="12xr3hmu3z8ir" />
                </span>
                <div data-id="element-24" data-mp="2bexh8vwawapi">
                  <h3 className="font-display text-sm font-extrabold text-navy" data-id="element-25" data-mp="2be4ahuxcdl7d">{b.title}</h3>
                  <p className="mt-0.5 text-[0.8rem] leading-snug text-navy/75 sm:text-sm" data-id="element-26" data-mp="27edmu0343l72">{b.desc}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}